import { SaveOutlined } from '@ant-design/icons';
import { Button, Col, Row, Tabs } from 'antd';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { currencyFormat } from '../../helpers/common';
import { layThongTinCauHinhThue, luuCauHinhThue } from '../../services/setting';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const CauHinhThueTab = () => {
    const [openModalLuu, setOpenModalLuu] = useState<boolean>(false);
    const dispatch = useDispatch();

    const { handleChange, values, handleSubmit, touched, errors, setFieldValue, setErrors, setTouched } = useFormik({
        initialValues: {
            soTienToiThieuTinhThueKTX: 2000000,
            soTienToiThieuTinhThueKTX_Str: "2.000.000",
        },
        validationSchema: Yup.object({
            soTienToiThieuTinhThueKTX: Yup.number().required('Bắt buộc').min(0, 'Không được nhỏ hơn 0'),
            soTienToiThieuTinhThueKTX_Str: Yup.string().required('Bắt buộc'),
        }),
        onSubmit: () => {
            setOpenModalLuu(true);
        }
    });

    const layThongTin = async () => {
        dispatch(showLoadingScreen());
        try {
            const data = await layThongTinCauHinhThue();
            const val = data?.soTienToiThieuTinhThueKTX ?? 2000000;
            setFieldValue("soTienToiThieuTinhThueKTX", val);
            setFieldValue("soTienToiThieuTinhThueKTX_Str", currencyFormat.formatMoney(val));
        } catch (err) {
            console.error(err);
        } finally {
            dispatch(hideLoadingScreen());
        }
    };

    const onSave = async (reqValues: any) => {
        try {
            dispatch(showLoadingScreen());
            const data = {
                soTienToiThieuTinhThueKTX: Number(reqValues.soTienToiThieuTinhThueKTX) || 0
            };
            const rs = await luuCauHinhThue(data);
            if (rs) {
                setErrors({});
                setTouched({});
                toast.success('Lưu thông tin cấu hình thuế thành công');
                setOpenModalLuu(false);
            } else {
                toast.error('Lưu thông tin cấu hình thuế không thành công');
                setOpenModalLuu(false);
            }
        } catch (err) {
            toast.error('Có lỗi xảy ra khi lưu cấu hình');
            setOpenModalLuu(false);
        } finally {
            dispatch(hideLoadingScreen());
        }
    };

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { name, value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        const formatted = parsedValue ? currencyFormat.formatMoney(parsedValue) : '';
        const baseName = name.replace('_Str', '');
        setFieldValue(baseName, parsedValue ? Number(parsedValue) : 0);
        setFieldValue(name, formatted);
    };

    useEffect(() => {
        layThongTin();
    }, []);

    return (
        <section style={{ marginTop: '20px' }}>
            {openModalLuu && (
                <ModalTextForm
                    show={openModalLuu}
                    title="Lưu thông tin"
                    handleClose={() => setOpenModalLuu(false)}
                    handleSave={() => { onSave(values); }}
                >
                    Xác nhận lưu thông tin cấu hình thuế?
                </ModalTextForm>
            )}
            <Row>
                <Col span={24}>
                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                        <Tabs
                            tabBarExtraContent={
                                <Button
                                    htmlType="submit"
                                    icon={<SaveOutlined rev="" />}
                                    type="primary"
                                >
                                    Lưu
                                </Button>
                            }
                            defaultActiveKey="1"
                            items={[
                                {
                                    key: '1',
                                    label: 'Cấu hình thuế',
                                    children: (
                                        <div className="card pt-3 pb-3">
                                            <div className="form-group row col-sm-12">
                                                <label className="col-sm-4 control-label">
                                                    <span className="text-red">*</span> Số tiền tối thiểu tính thuế KTX (VNĐ):
                                                </label>
                                                <div className="col-sm-4">
                                                    <Form.Control
                                                        id="soTienToiThieuTinhThueKTX_Str"
                                                        name="soTienToiThieuTinhThueKTX_Str"
                                                        type="text"
                                                        placeholder="Số tiền tối thiểu tính thuế"
                                                        onChange={handleChangeCurrency}
                                                        value={values.soTienToiThieuTinhThueKTX_Str}
                                                        isValid={touched.soTienToiThieuTinhThueKTX_Str && !errors.soTienToiThieuTinhThueKTX_Str}
                                                        isInvalid={touched.soTienToiThieuTinhThueKTX_Str && !!errors.soTienToiThieuTinhThueKTX_Str}
                                                    />
                                                    {touched.soTienToiThieuTinhThueKTX_Str && errors.soTienToiThieuTinhThueKTX_Str ? (
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.soTienToiThieuTinhThueKTX_Str}
                                                        </Form.Control.Feedback>
                                                    ) : null}
                                                    <Form.Control
                                                        id="soTienToiThieuTinhThueKTX"
                                                        name="soTienToiThieuTinhThueKTX"
                                                        hidden
                                                        type="text"
                                                        onChange={handleChange}
                                                        value={values.soTienToiThieuTinhThueKTX}
                                                    />
                                                    <small className="text-muted mt-1 d-block">
                                                        <i>(Thuế TNCN 10% tính cho từng lần chi đạt từ mức này trở lên. Mặc định là 2.000.000 VNĐ)</i>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            ]}
                        />
                    </form>
                </Col>
            </Row>
        </section>
    );
};

export default CauHinhThueTab;
